/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import {
  FormControl,
  FormControlLabel,
  MenuItem,
  Radio,
  RadioGroup,
  TextField,
} from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { Button, Tooltip } from 'react-bootstrap';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import _ from 'lodash';
import { Grid } from '@mui/material';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import DisplaySuccessMessages from '../../../../SharedModules/Errors/SuccessMessage';
import TableGrid from '../../../../SharedModules/Table/TableGridWithFeatures';
import {
  navigateToNextCell,
  onCellFocused,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';
import * as CONSTANTS from '../../../../SharedModules/AppConstants';
import Spinner from '../../../../SharedModules/Spinner/Spinner';
import { NDC_TABS_DATA } from '../../NDC/utility/constants';
import {
  dispatchErrorMessages,
  dispatchSuccessMessages,
  getCalculatedData,
  getDrugFamily,
  getManufacturerListAndNdc,
  getMaxQuarterForFreezeDt,
  getRebateProgramCode,
  setDrugFamilySelectedRows,
  setDrugFamilyTableData,
  setManufactuererSelectedRows,
  setURASearchFormValues,
} from '../store/actions';
import {
  DRUG_FAMILY_HEAD,
  DRUG_MANUFACTURER_HEAD,
  MANUFACTURER_HEAD,
} from './gridComponents/tableHead';
import SearchByNDC from './SearchByNDC';
import {
  handleScrollToEvent,
  quarterFormatter,
  redirectURLLink,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import SearchByDrugName from './SearchByDrugName';
import SearchByLabeler from './SearchByLabeler';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import ErrorPopup from '../../NDC/component/ErrorPopup';
import { getUserDefaults } from '../../../System/UserDefault/store/actions';
import { autoFormateDate } from '../../../../SharedModules/utilities/utilities';

export const planTypeList = [
  { label: 'Medicaid', value: 'FD' },
  { label: 'Commercial', value: 'COMM' },
  { label: 'State', value: 'ST' },
  { label: 'Supplemental', value: 'SUPP' },
];
export const selectOneOptionList = [
  { name: 'Manufacturer', value: 'Manufacturer' },
  { name: 'NDC', value: 'NDC' },
];
export const selectOneOptionTwoList = [
  { name: 'Drug Family', value: 'drugfamily' },
  { name: 'NDC', value: 'NDC' },
];
export const quarterOptionList = [
  { label: 'All', value: 'all' },
  { label: 'Target', value: 'target' },
  { label: 'Calculated', value: 'calculated' },
];

const URASearch = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const [fullScreenView, setFullScreenView] = useState(false);
  const [error, setError] = useState(null);
  const [clickedViewButton, setClickedViewButton] = useState(false);
  const [isMounted, setIsMounted] = useState(false);
  const [manufacturerGridApi, setManufacturerGridApi] = useState(null);
  const [drugFamilyGridApi, setDrugFamilyGridApi] = useState(null);

  const loading = useSelector(
    (state) => state.sharedState.URASearchReducer.loading
  );
  const errorMessages = useSelector(
    (state) => state.sharedState.URASearchReducer.errorMessages
  );
  const successMessages = useSelector(
    (state) => state.sharedState.URASearchReducer.successMessages
  );
  const URASearchFormValues = useSelector(
    (state) => state.sharedState.URASearchReducer.URASearchFormValues
  );
  const rebateProgramCode = useSelector(
    (state) => state.sharedState.URASearchReducer.rebateProgramCode?.data
  );
  const manufacturersData = useSelector(
    (state) => state.sharedState.URASearchReducer.manufacturersData
  );
  const DrugFamilyTableData =
    useSelector(
      (state) => state.sharedState.URASearchReducer.DrugFamilyTableData
    ) ?? [];
  const calculatedURAHeaderDataList = useSelector(
    (state) => state.sharedState.URASearchReducer.calculatedURAHeaderDataList
  );
  const manufacturerSelectedRows = useSelector(
    (state) => state.sharedState.URASearchReducer.manufacturerSelectedRows
  );
  const drugFamilySelectedRows = useSelector(
    (state) => state.sharedState.URASearchReducer.drugFamilySelectedRows
  );
  const userDefaults = useSelector(
    (state) => state.sharedState.UserDefaultReducer.UserDefaultsValues?.data
  );
  const defaultQtrRIC = useSelector(
    (state) => state.sharedState.URASearchReducer.defaultQtrRIC?.data ?? ''
  );
  const calculatedURAErrorMessage = useSelector(
    (state) =>
      state.sharedState.URASearchReducer.calculatedURAErrorMessage ?? ''
  );

  const getUserDefaultValues = (value) => dispatch(getUserDefaults(value));

  const setErrorMessages = (messages) => {
    dispatch(dispatchErrorMessages(messages));
  };

  const setSuccessMessages = (messages) => {
    dispatch(dispatchSuccessMessages(messages));
  };
  const logInUser = useSelector(
    (state) => state?.sharedState?.SharedReducer?.logInUser
  );

  useEffect(() => {
    getUserDefaultValues(logInUser);
    dispatch(getMaxQuarterForFreezeDt());
    dispatch(
      setURASearchFormValues({
        ...URASearchFormValues,
        planType: !URASearchFormValues?.planType
          ? userDefaults?.planTypeCd
          : URASearchFormValues?.planType,
        rebateProgramCd:
          !URASearchFormValues?.rebateProgramCd ||
          URASearchFormValues?.rebateProgramCd === '-1'
            ? userDefaults?.rebateProgramCd
            : URASearchFormValues?.rebateProgramCd,
        selectOneOption:
          URASearchFormValues.planType === 'COMM' ||
          URASearchFormValues.planType === 'SUPP'
            ? selectOneOptionTwoList[0].value
            : selectOneOptionList[0].value,
      })
    );
    handleScrollToEvent();
  }, []);

  useEffect(() => {
    if (clickedViewButton) {
      setClickedViewButton(false);
      if (calculatedURAHeaderDataList?.length > 0) {
        redirectURLLink(
          '/selected-ura',
          'View Calculated URA Detail',
          history,
          dispatch
        );
      } else {
        setError(calculatedURAErrorMessage ?? 'No Calculated URA');
      }
    }
  }, [calculatedURAHeaderDataList]);

  // highlight tab if it has error
  useEffect(() => {
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
    const newObj =
      updateTabs &&
      updateTabs.length > 0 &&
      updateTabs.map((item) => {
        if (item.navTo === '/ura-search') {
          if (errorMessages?.length > 0) {
            item.isFormError = true;
          } else {
            item.isFormError = false;
          }
        }
        return item;
      });
    localStorage.setItem('tabItemsData', JSON.stringify(newObj));
  }, [errorMessages]);

  useEffect(() => {
    if (
      isMounted &&
      (URASearchFormValues.selectOneOption === selectOneOptionList[0].value ||
        URASearchFormValues.selectOneOption ===
          selectOneOptionTwoList[0].value) &&
      validateCalculatedURAReuqest()
    ) {
      dispatch(
        getManufacturerListAndNdc({
          selectOneOption: 'manufacturer',
          quarter: URASearchFormValues.quarter || null,
          planType:
            URASearchFormValues.planType === 'FD' ||
            URASearchFormValues.planType === 'ST'
              ? 'G'
              : 'commercial',
          rebateProgramCd: URASearchFormValues.rebateProgramCd,
          mfgTypeCd:
            URASearchFormValues.planType === 'FD' ||
            URASearchFormValues.planType === 'ST'
              ? 'G'
              : 'C',
          qtrType:
            URASearchFormValues.quarters === 'all'
              ? 'ALL'
              : URASearchFormValues.quarters === 'target'
              ? 'TARGET'
              : 'CALC',
        })
      );
    }
  }, [URASearchFormValues]);

  useEffect(() => {
    if (isMounted && URASearchFormValues.planType) {
      dispatch(getRebateProgramCode(URASearchFormValues.planType));
    }
    setIsMounted(true);
  }, [URASearchFormValues.planType]);

  useEffect(() => {
    if (URASearchFormValues.quarters !== quarterOptionList[0].value) {
      dispatch(
        setURASearchFormValues({
          ...URASearchFormValues,
          quarter: !URASearchFormValues?.quarter
            ? defaultQtrRIC
            : URASearchFormValues?.quarter,
        })
      );
    }
  }, [URASearchFormValues.quarters]);

  const handleChange = (e) => {
    setErrorMessages([]);
    setSuccessMessages([]);
    dispatch(
      setURASearchFormValues({
        ...URASearchFormValues,
        [e.target.name]: e.target.value,
        ...('planType' in URASearchFormValues &&
          e.target.name === 'planType' && { rebateProgramCd: '-1' }),
      })
    );
  };

  const handleOnBlur = (e) => {
    const quarter = autoFormateDate(e?.target?.value?.toUpperCase());
    dispatch(
      setURASearchFormValues({
        ...URASearchFormValues,
        quarter,
      })
    );
  };

  const onGridReadyManufacturerTable = (params) => {
    setManufacturerGridApi(params.api);
  };

  const onGridReadyDrugFamilyTable = (params) => {
    setDrugFamilyGridApi(params.api);
  };

  const onManufactuererSelectionChanged = () => {
    const selectedRows = manufacturerGridApi.getSelectedRows();
    dispatch(setManufactuererSelectedRows(selectedRows));
    if (
      URASearchFormValues.selectOneOption === selectOneOptionTwoList[0].value
    ) {
      if (selectedRows?.length > 0) {
        dispatch(
          getDrugFamily({
            mfgId: selectedRows[0]?.mfgId,
            qtrType: 'ALL',
            rpc: URASearchFormValues.rebateProgramCd,
          })
        );
      } else {
        dispatch(setDrugFamilyTableData([]));
      }
    }
  };

  const onDrugFamilySelectionChanged = () => {
    const selectedRows = drugFamilyGridApi.getSelectedRows();
    dispatch(setDrugFamilySelectedRows(selectedRows));
  };

  useEffect(() => {
    if (manufacturerGridApi && manufacturerSelectedRows.length > 0) {
      manufacturerGridApi.forEachNode((node) => {
        if (manufacturerSelectedRows.find((row) => _.isEqual(row, node.data))) {
          node.setSelected(true);
        }
      });
    }
  }, [manufacturerGridApi]);

  useEffect(() => {
    if (drugFamilyGridApi && drugFamilySelectedRows.length > 0) {
      drugFamilyGridApi.forEachNode((node) => {
        if (drugFamilySelectedRows.find((row) => _.isEqual(row, node.data))) {
          node.setSelected(true);
        }
      });
    }
  }, [drugFamilyGridApi]);

  useEffect(() => {
    if (drugFamilyGridApi) {
      drugFamilyGridApi.forEachNode((node) => {
        if (drugFamilySelectedRows.includes(node.data)) {
          node.setSelected(true);
        }
      });
    }
  }, [drugFamilySelectedRows, drugFamilyGridApi]);

  const validateCalculatedURAReuqest = () => {
    const errorMessageList = [];
    if (!URASearchFormValues.planType) {
      errorMessageList.push('Plan Type is required.');
    }
    if (!URASearchFormValues.selectOneOption) {
      errorMessageList.push('Select One is required.');
    }
    if (
      !URASearchFormValues.rebateProgramCd ||
      URASearchFormValues.rebateProgramCd === '-1'
    ) {
      errorMessageList.push('Rebate Program is required.');
    }
    if (
      URASearchFormValues.quarters !== quarterOptionList[0].value &&
      !URASearchFormValues.quarter
    ) {
      errorMessageList.push('Quarter is required.');
    }
    if (
      URASearchFormValues.quarter !== '' &&
      !quarterFormatter(URASearchFormValues.quarter)
    ) {
      errorMessageList.push(CONSTANTS.QUARTER_FORMAT_ERROR);
    }

    setErrorMessages(errorMessageList);
    return errorMessageList.length === 0;
  };

  const handleFullScreenViewClick = () => {
    setFullScreenView(!fullScreenView);
  };

  const handleViewDetailsClick = async () => {
    if (validateCalculatedURAReuqest()) {
      let selectedRows = [];
      if (
        URASearchFormValues.selectOneOption === selectOneOptionList[0].value
      ) {
        selectedRows = manufacturerGridApi?.getSelectedRows();
        if (selectedRows?.length > 0) {
          const requestData = {
            drugFamilyseqNum: ['-1'],
            ndcList: ['-1'],
            mfgIdList: selectedRows.map((item) => String(item.mfgId)),
            rebateProgramCd: URASearchFormValues.rebateProgramCd,
            selectOneOption: 'mfg',
            planType:
              URASearchFormValues.planType === 'FD' ||
              URASearchFormValues.planType === 'ST'
                ? 'G'
                : 'C',
            qtrType:
              URASearchFormValues.quarters === 'all'
                ? 'ALL'
                : URASearchFormValues.quarters === 'target'
                ? 'TARGET'
                : 'CALC',
            ...(URASearchFormValues.quarters !== 'all' && {
              startQtr: URASearchFormValues.quarter,
            }),
          };
          dispatch(getCalculatedData(requestData));
          setClickedViewButton(true);
        } else {
          dispatch(
            dispatchErrorMessages([
              'You have not selected any Manufacturer to view the calculated URA.',
            ])
          );
        }
      } else if (
        URASearchFormValues.selectOneOption === selectOneOptionTwoList[0].value
      ) {
        selectedRows = drugFamilyGridApi?.getSelectedRows();
        if (selectedRows?.length > 0) {
          const requestData = {
            drugFamilyseqNum: selectedRows?.map((item) =>
              String(item.familySeqNum)
            ),
            ndcList: ['-1'],
            mfgIdList: ['-1'],
            rebateProgramCd: URASearchFormValues.rebateProgramCd,
            selectOneOption: 'drugfamily',
            planType:
              URASearchFormValues.planType === 'FD' ||
              URASearchFormValues.planType === 'ST'
                ? 'G'
                : 'C',
            qtrType:
              URASearchFormValues.quarters === 'all'
                ? 'ALL'
                : URASearchFormValues.quarters === 'target'
                ? 'TARGET'
                : 'CALC',
            ...(URASearchFormValues.quarters !== 'all' && {
              startQtr: URASearchFormValues.quarter,
            }),
          };
          dispatch(getCalculatedData(requestData));
          setClickedViewButton(true);
        } else {
          dispatch(
            dispatchErrorMessages([
              'You have not selected any Drug Family to view the calculated URA.',
            ])
          );
        }
      }
    }
  };

  const frameworkComponents = {
    mfgNameRederer: (cellInfo) => {
      const name = cellInfo.data && cellInfo.data.mfgName;
      if (name && name.length > 25) {
        return (
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip id="labeler-tooltip">{name}</Tooltip>}
          >
            <div>{name}</div>
          </OverlayTrigger>
        );
      }
      return <div>{name}</div>;
    },
  };

  // if (!rebateProgramCode || rebateProgramCode.length === 0) {
  //   return (
  //     <TextField
  //       label="Rebate Program"
  //       fullWidth
  //       select
  //       placeholder=""
  //       InputLabelProps={{
  //         shrink: true,
  //       }}
  //       required
  //       onChange={handleChange}
  //       id="rebateProgramCd"
  //       name="rebateProgramCd"
  //       value={URASearchFormValues.rebateProgramCd}
  //     >
  //       <MenuItem key="" value="-1" className="frr-dropdown-blank-item" />
  //     </TextField>
  //   );
  // }

  // Find the rebate program object based on the selected rebateProgramCd
  const selectedRebateProgram = rebateProgramCode?.find(
    (item) => item.rebateProgramCd === URASearchFormValues.rebateProgramCd
  );

  // Tooltip content with rebateProgramCd and shortDescr
  const tooltipContent = (
    <Tooltip id="labeler-tooltip">
      {URASearchFormValues?.rebateProgramCd === '-1'
        ? null
        : `${URASearchFormValues?.rebateProgramCd} | ${
            selectedRebateProgram ? selectedRebateProgram?.shortDescr : ''
          }`}
    </Tooltip>
  );

  return (
    <div className="custom-check">
      <div className="panel tBillPanel-space devider-line pb-0">
        {loading && <Spinner load={loading} />}
        <CustomSeparator parent1="Display" parent2="Calculated URA" />
        {!fullScreenView && (
          <>
            <DisplayErrorMessages errorMessages={errorMessages} />
            <DisplaySuccessMessages successMessages={successMessages} />
            <div className="panel mb-3">
              <div className="row">
                <div className="col-sm-4">
                  <fieldset className="custom-fieldset">
                    <legend className="same-font-family" id="plan_type_label">
                      Plan Type <span className="mandatory"> *</span>{' '}
                    </legend>
                    <div className="form-wrapper p-0 mt-2">
                      <div className="mui-custom-form input-md field-xl">
                        <div className="sub-radio no-margin">
                          <FormControl>
                            <RadioGroup
                              aria-labelledby="plan_type_label"
                              name="planType"
                              onChange={handleChange}
                              value={URASearchFormValues.planType}
                              required
                            >
                              <Grid container spaceing={2}>
                                {planTypeList.map((option, index) => (
                                  <Grid
                                    item
                                    xs={12}
                                    lg={6}
                                    key={`plan-type-${index}`}
                                  >
                                    <FormControlLabel
                                      style={{ marginRight: '10px' }}
                                      value={option.value}
                                      control={<Radio />}
                                      label={option.label}
                                      data-test={option.label}
                                    />
                                  </Grid>
                                ))}
                              </Grid>
                            </RadioGroup>
                          </FormControl>
                        </div>
                      </div>
                    </div>
                  </fieldset>
                </div>

                {/* Select One Option */}
                <div className="col-sm-4">
                  <fieldset className="custom-fieldset">
                    <legend
                      className="same-font-family"
                      id="select_one_option_label"
                    >
                      Select One Option <span className="mandatory"> *</span>{' '}
                    </legend>
                    <div className="form-wrapper p-0 mt-2 h-100">
                      <div className="mui-custom-form input-md field-xl d-flex align-items-center">
                        <div className="sub-radio no-margin w-100">
                          <FormControl>
                            <RadioGroup
                              row
                              aria-labelledby="select_one_option_label"
                              name="selectOneOption"
                              onChange={handleChange}
                              value={URASearchFormValues.selectOneOption}
                              required
                            >
                              {(URASearchFormValues.planType === 'FD' ||
                                URASearchFormValues.planType === 'ST') &&
                                selectOneOptionList.map((option, index) => (
                                  <FormControlLabel
                                    key={`select-by-${index}`}
                                    style={{
                                      marginRight: '10px',
                                      width: '45%',
                                    }}
                                    value={option.value}
                                    control={<Radio />}
                                    label={option.name}
                                  />
                                ))}
                              {(URASearchFormValues.planType === 'COMM' ||
                                URASearchFormValues.planType === 'SUPP') &&
                                selectOneOptionTwoList.map((option, index) => (
                                  <FormControlLabel
                                    key={`select-by-${index}`}
                                    style={{
                                      marginRight: '10px',
                                      width: '45%',
                                    }}
                                    value={option.value}
                                    control={<Radio />}
                                    label={option.name}
                                  />
                                ))}
                            </RadioGroup>
                          </FormControl>
                        </div>
                      </div>
                    </div>
                  </fieldset>
                </div>

                {/* Rebate Program */}
                <div className="col-sm-4">
                  <fieldset className="custom-fieldset">
                    <legend
                      className="same-font-family"
                      id="rebate_program_code_label"
                    >
                      Rebate Program <span className="mandatory"> *</span>{' '}
                    </legend>
                    <div className="form-wrapper p-0 h-100">
                      <div className="mui-custom-form with-select field-xl no-lbl d-flex align-items-center">
                        <OverlayTrigger
                          placement="bottom"
                          overlay={tooltipContent}
                        >
                          <TextField
                            label="Rebate Program"
                            fullWidth
                            select
                            placeholder=""
                            InputLabelProps={{
                              shrink: true,
                            }}
                            inputProps={{
                              'aria-labelledby': 'rebate_program_code_label',
                            }}
                            required
                            onChange={handleChange}
                            name="rebateProgramCd"
                            value={URASearchFormValues?.rebateProgramCd || '-1'}
                          >
                            <MenuItem
                              key=""
                              value="-1"
                              className="frr-dropdown-blank-item"
                            />
                            {rebateProgramCode?.map((item) => (
                              <MenuItem
                                key={item.rebateProgramCd}
                                value={item.rebateProgramCd}
                              >
                                {`${item.rebateProgramCd} | ${item.shortDescr}`}
                              </MenuItem>
                            ))}
                          </TextField>
                        </OverlayTrigger>
                      </div>
                    </div>
                  </fieldset>
                </div>
              </div>

              <div className="row mt-3">
                {/* Quarters */}
                <div className="col-sm-8">
                  <fieldset className="custom-fieldset">
                    <legend className="same-font-family" id="quarters_label">
                      Quarters <span className="mandatory"> *</span>{' '}
                    </legend>
                    <div className="form-wrapper p-0 mt-2">
                      <div className="mui-custom-form input-md field-xl">
                        <div className="sub-radio no-margin">
                          <FormControl>
                            <RadioGroup
                              row
                              name="quarters"
                              aria-labelledby="quarters_label"
                              onChange={handleChange}
                              value={URASearchFormValues.quarters}
                              required
                            >
                              {quarterOptionList.map((option, index) => (
                                <FormControlLabel
                                  key={`quarters-${index}`}
                                  style={{ marginRight: '10px', width: '30%' }}
                                  value={option.value}
                                  control={<Radio />}
                                  label={option.label}
                                />
                              ))}
                            </RadioGroup>
                          </FormControl>
                        </div>
                      </div>
                    </div>
                  </fieldset>
                </div>

                {/* Search Type */}
                {URASearchFormValues.selectOneOption ===
                  selectOneOptionList[1].value && (
                  <div className="col-sm-4">
                    <fieldset className="custom-fieldset">
                      <legend className="same-font-family">
                        Search Type <span className="mandatory"> *</span>{' '}
                      </legend>
                      <div className="p-0 mt-2 row">
                        <div className="mui-custom-form col-12 m-0">
                          <div className="sub-radio no-margin">
                            <FormControl>
                              <RadioGroup
                                row
                                value={URASearchFormValues.searchType}
                                onChange={handleChange}
                                name="searchType"
                                className="justify-content-between justify-content-around"
                              >
                                {NDC_TABS_DATA.map((item, index) => (
                                  <FormControlLabel
                                    value={item.value}
                                    control={<Radio />}
                                    label={item.name}
                                    id={item.value}
                                    key={index}
                                  />
                                ))}
                              </RadioGroup>
                            </FormControl>
                          </div>
                        </div>
                      </div>
                    </fieldset>
                  </div>
                )}

                {/* Quarter */}
                <div className="col-sm-4">
                  <fieldset className="custom-fieldset">
                    <legend className="same-font-family" id="quarter_label">
                      Quarter
                    </legend>
                    <div className="form-wrapper p-0">
                      <div className="mui-custom-form with-select field-xl no-lbl">
                        <TextField
                          fullWidth
                          required
                          placeholder=""
                          name="quarter"
                          value={URASearchFormValues.quarter}
                          onChange={handleChange}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          inputProps={{
                            maxLength: 6,
                            'aria-labelledby': 'quarter_label',
                          }}
                          disabled={
                            URASearchFormValues.quarters ===
                            quarterOptionList[0].value
                          }
                          onBlur={handleOnBlur}
                        />
                      </div>
                    </div>
                  </fieldset>
                </div>
              </div>
            </div>
          </>
        )}
        {URASearchFormValues.selectOneOption === selectOneOptionList[0].value ||
        URASearchFormValues.selectOneOption ===
          selectOneOptionTwoList[0].value ? (
          <div className="panel tBillPanel-space p-0">
            <div className="FRR-custom-table tbl-manufacturer-home unallocated">
              <div className="frr-tbl-with-feature">
                {URASearchFormValues.selectOneOption ===
                  selectOneOptionList[0].value && (
                  <TableGrid
                    gridHeight={fullScreenView ? '100vh' : 350}
                    rowData={manufacturersData || []}
                    columnDefs={MANUFACTURER_HEAD}
                    exportFile
                    fileName="View Calculated URA"
                    data-testid="onEditingStopped"
                    rowMultiSelectWithClick
                    enterMovesDown
                    suppressCellFocus
                    rowSelection="multiple"
                    onSelectionChanged={onManufactuererSelectionChanged}
                    onGridReady={onGridReadyManufacturerTable}
                    onCellFocused={onCellFocused}
                    navigateToNextCell={navigateToNextCell}
                    // tabToNextCell={tabToNextCell}
                    handleFullScreenViewClick={handleFullScreenViewClick}
                    frameworkComponents={frameworkComponents}
                  />
                )}
                {URASearchFormValues.selectOneOption ===
                  selectOneOptionTwoList[0].value && (
                  <>
                    <TableGrid
                      gridHeight={fullScreenView ? '100vh' : 300}
                      rowData={manufacturersData || []}
                      columnDefs={DRUG_MANUFACTURER_HEAD}
                      data-testid="onEditingStopped"
                      exportFile
                      fileName="View Calculated URA"
                      rowMultiSelectWithClick
                      enterMovesDown
                      suppressCellFocus
                      onSelectionChanged={onManufactuererSelectionChanged}
                      onGridReady={onGridReadyManufacturerTable}
                      onCellFocused={onCellFocused}
                      navigateToNextCell={navigateToNextCell}
                      tabToNextCell={tabToNextCell}
                      handleFullScreenViewClick={handleFullScreenViewClick}
                    />
                    <TableGrid
                      gridHeight={fullScreenView ? '100vh' : 300}
                      rowData={DrugFamilyTableData || []}
                      columnDefs={DRUG_FAMILY_HEAD}
                      data-testid="onEditingStopped"
                      exportFile
                      fileName="View Calculated URA"
                      enterMovesDown
                      suppressCellFocus
                      rowSelection="multiple"
                      onSelectionChanged={onDrugFamilySelectionChanged}
                      onGridReady={onGridReadyDrugFamilyTable}
                      onCellFocused={onCellFocused}
                      navigateToNextCell={navigateToNextCell}
                      tabToNextCell={tabToNextCell}
                      handleFullScreenViewClick={handleFullScreenViewClick}
                    />
                  </>
                )}
              </div>
            </div>
            <div className="d-flex align-items-center justify-content-end my-3">
              <Button
                className="btn btn-success btn-view"
                onClick={() => handleViewDetailsClick()}
              >
                <SVGComponent iconName="Icon-view" />
                View Calculated URA
              </Button>
            </div>
          </div>
        ) : null}
        {URASearchFormValues.selectOneOption ===
        selectOneOptionList[1].value ? (
          <React.Fragment>
            {URASearchFormValues.searchType === NDC_TABS_DATA[0].value ? (
              <SearchByNDC
                fullScreen={fullScreenView}
                setFullScreen={setFullScreenView}
                setError={setErrorMessages}
                validateForm={validateCalculatedURAReuqest}
                setClickedViewButton={setClickedViewButton}
              />
            ) : null}
            {URASearchFormValues.searchType === NDC_TABS_DATA[1].value ? (
              <SearchByDrugName
                fullScreen={fullScreenView}
                setFullScreen={setFullScreenView}
                setError={setErrorMessages}
                validateForm={validateCalculatedURAReuqest}
                setClickedViewButton={setClickedViewButton}
              />
            ) : null}
            {URASearchFormValues.searchType === NDC_TABS_DATA[2].value ? (
              <SearchByLabeler
                fullScreen={fullScreenView}
                setFullScreen={setFullScreenView}
                setError={setErrorMessages}
                validateForm={validateCalculatedURAReuqest}
                setClickedViewButton={setClickedViewButton}
              />
            ) : null}
          </React.Fragment>
        ) : null}
        <ErrorPopup
          modalTitle="Calculated URA"
          errorPopupMessage={error}
          onClose={() => setError(null)}
        />
        <div className="clearfix" />
      </div>
    </div>
  );
};

export default URASearch;
